<template>
  <div class="empty-requests-page"
       :class="requestsPageStyles">
    <div class="requests">
      <div v-if="$mq !== 'mobile'"
           class="requests-icon">
        <icon-question :width="this.$mq === 'mobile' ? '50' : '100'"
                       :height="this.$mq === 'mobile' ? '50' : '100'"
                       iconColor="#8067b7" />
      </div>
    </div>

    {{ $t("childRequests.noRequestsYet") }}

    <base-button class="retry-button"
                 color="primary"
                 :loading="loading"
                 @click="$emit('retry')">
      {{ $t("tabs.tapToRetry") }}
    </base-button>
  </div>
</template>

<script>
  export default {
    props: {
      loading: {
        required: true,
        type: Boolean
      }
    },

    computed: {
      requestsPageStyles() {
        return {
          'empty-requests-page-mobile': this.$mq === 'mobile'
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .empty-requests-page {
    width: 100%;
    height: 100%;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .requests {
      text-align: center;

      &-icon {
        background: color.adjust(map.get($colors, primary), $lightness: 40%);

        padding: 50px;
        margin-bottom: 20px;
        border-radius: 50%;

        display: flex;
        justify-content: center;
      }
    }

    .retry-button {
      margin: 12px auto;
    }
  }

  .empty-requests-page-mobile {
    .requests {
      &-icon {
        padding: 40px;
        margin-bottom: 10px;
      }

      .retry-button {
        margin: 10px auto;
      }
    }
  }
</style>
